import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useGetEstateAnalyticaForYearDataQuery, useGetEstateAnalyticalPurposeOwnershipDataQuery, useGetEstateAnalyticalbyconditionDataQuery, useGetReportRealEstateMutation } from "../../../../redux/api/realEstate/realEstateApi";
import { useGetMovableAnalyticalDataQuery } from "./api/index"
import { useState, useEffect } from "react";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import { PreloaderSvg } from "../../../preloaderSvg/PreloaderSvg";
import { MovablePropertyMap } from "./map";
import style from './style.module.css';
import { PlusOutlined } from "@ant-design/icons";
import { useReportMovablePropertyMutation } from "../../../../redux/api/movableProperty";
import ReportMovableProperty from "../../../../pages/admin/movableProperty/ReportMovableProperty";
import L from "leaflet";
import { MapWithPoligons } from "../../../MapWithPoligons";
import { GeneralData } from "../..";


export interface ImmovableBlockProps {
    alias: string;
    year?: number;
}

export const MovablePropertyBlock: React.FC<ImmovableBlockProps> = ({ alias, year }) => {
    const { t } = useTranslation();
    const [showReportModal, setShowReportModal] = useState<boolean>(false);
    const [getReportMovableProperty] = useReportMovablePropertyMutation();
    const currentYear = year || new Date().getFullYear();

    const { data: movableData, isLoading: isLoadingMovable } = useGetMovableAnalyticalDataQuery({
        governmentAlias: alias
    });
    const customMarkerIcon = L.icon({
        iconUrl: '/imort.svg',
        iconSize: [35, 55],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
    });
    const getReport = async (payload: {
        periodStart: string;
        periodEnd: string;
        language: string,
        governmentAlias: string | null
    }): Promise<Blob> => {
        return await getReportMovableProperty(payload).unwrap();
    };

    if (isLoadingMovable) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <PreloaderSvg />
            </div>
        );
    }

    return (
        <div className={style.container_main}>
            {/* <GeneralData/> */}
            <div className={style.title}>
                <h1>Движимое имущество - {movableData?.res?.[0]?.organizationNameRu || t('Data not available')}</h1>
                <Button 
                    style={{ marginLeft: '5px' }} 
                    type="primary" 
                    icon={<img src="../../../report.svg" alt="Plus Icon" style={{ width: '16px', height: '16px' }} />}
                    onClick={() => setShowReportModal(true)}
                >
                    {t('reports.report_by_movable_property')}
                </Button>
                <ReportMovableProperty
                    getReport={getReport}
                    show={showReportModal}
                    onHide={() => setShowReportModal(false)}
                />
            </div>

            <div className={style.container}>
                <div className={style.content}>
                <MapWithPoligons
                        extraData={movableData?.res?.map(item => ({
                            ...item,
                            popupContent: `
                               <div style="padding: 8px;">
                    <h4 style="margin: 0 0 8px 0; color: #333; font-size: 16px;">
                        ${item.organizationNameRu}
                    </h4>
                    <p style="margin: 4px 0; color: #666;">
                        <strong style="color: #333;">Название:</strong> ${item.name}
                    </p>
                    <p style="margin: 4px 0; color: #666;">
                        <strong style="color: #333;">Марка:</strong> ${item.brand}
                    </p>
                    <p style="margin: 4px 0; color: #666;">
                        <strong style="color: #333;">Модель:</strong> ${item.model}
                    </p>
                    <p style="margin: 4px 0; color: #666;">
                        <strong style="color: #333;">Количество:</strong> ${item.quantity}
                    </p>
                    <p style="margin: 4px 0; color: #666;">
                        <strong style="color: #333;">Состояние:</strong> ${item.condition}
                    </p>
                    <p style="margin: 4px 0; color: #666;">
                        <strong style="color: #333;">Адрес:</strong> ${item.address}
                    </p>
                    <p style="margin: 4px 0; color: #666;">
                        <strong style="color: #333;">Район:</strong> ${item.territorialUnitNameRu}
                    </p>
                </div>
                            `
                        }))}
                        latitude={41.5089324}
                        longitude={74.724091}
                        customIcon={customMarkerIcon}
                        type={["REGION"]}
                    />
                    <div className={style.topRow}>
                    </div>
                    <div className={style.tables}>
                    </div>
                </div>
            </div>
        </div>
    );
};
